import { useSendSMS } from "./hook";
import { SendSMSTemplate } from "views/components/templates/sendSMS";

export const SendSMS = () => {
  const tempProps = useSendSMS();
  return <SendSMSTemplate {...tempProps} />;
};
